/*
 * Yurls Shop — productgalerij.
 *
 * Een grote afbeelding met miniaturen eronder. Klikken op een miniatuur wisselt
 * de grote afbeelding. Werkt ook met het toetsenbord: de miniaturen zijn echte
 * knoppen, en met de pijltjestoetsen loop je erdoorheen.
 *
 * Zonder JavaScript blijven alle afbeeldingen gewoon staan — de miniaturen zijn
 * dan links naar de afbeelding zelf.
 *
 * De galerij zet geen bijschrift meer onder de grote afbeelding. Stond er eerder
 * 'pagina 1' in beeld, dan kwam die tekst hiervandaan: het label van de
 * miniatuur werd naar een span geschreven. Dat is er bewust uit.
 *
 * Verwachte opbouw:
 *   <yurls-gallery>
 *     <img data-main>
 *     <button data-thumb data-src="..." data-srcset="..." data-alt="...">
 *   </yurls-gallery>
 */

if (!customElements.get('yurls-gallery')) {
  customElements.define(
    'yurls-gallery',
    class YurlsGallery extends HTMLElement {
      connectedCallback() {
        this.main = this.querySelector('[data-main]');
        this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));

        if (!this.main || this.thumbs.length === 0) return;

        this.onClick = (event) => {
          const thumb = event.currentTarget;
          this.select(this.thumbs.indexOf(thumb));
        };

        this.onKey = (event) => {
          const current = this.thumbs.indexOf(event.currentTarget);
          let next = null;
          if (event.key === 'ArrowRight') next = current + 1;
          if (event.key === 'ArrowLeft') next = current - 1;
          if (next === null) return;
          event.preventDefault();
          // Rondlopen: voorbij de laatste kom je weer bij de eerste uit.
          const target = (next + this.thumbs.length) % this.thumbs.length;
          this.select(target);
          this.thumbs[target].focus();
        };

        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', this.onClick);
          thumb.addEventListener('keydown', this.onKey);
        });

        this.select(0);
      }

      disconnectedCallback() {
        this.thumbs.forEach((thumb) => {
          thumb.removeEventListener('click', this.onClick);
          thumb.removeEventListener('keydown', this.onKey);
        });
      }

      select(index) {
        const thumb = this.thumbs[index];
        if (!thumb) return;

        if (thumb.dataset.src) this.main.src = thumb.dataset.src;
        if (thumb.dataset.srcset) this.main.srcset = thumb.dataset.srcset;
        this.main.alt = thumb.dataset.alt || '';

        this.thumbs.forEach((other, i) => {
          const active = i === index;
          other.toggleAttribute('data-active', active);
          other.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }
    }
  );
}
